import type {GenericAsset} from '../../../../../brand/lib/types/contentful'
import {Image} from '@primer/react-brand/esm'
import styles from './HeroTabs.module.css'
import {BackgroundGrid} from '../../../../../brand/components/BackgroundGrid'

// Use a `GenericAsset` with an id of `showBackgroundGrid` to enable the WebGL BackgroundGrid.
// Without, the GenericAsset's image will be used as fallback.

type Props = {
  component: GenericAsset
}

export function HeroTabsBackground({component}: Props) {
  if (component.fields.id === 'showBackgroundGrid') {
    return <BackgroundGrid theme="dark" hasCornerDots hasCursorTrain className={styles.HeroTabsBackgroundGrid} />
  }

  const asset = component.fields.asset?.fields
  const description = asset?.description || ''
  const file = asset?.file
  const image = file?.details?.image

  return image ? (
    <Image
      src={file.url}
      alt={description}
      width={image.width}
      height={image.height}
      className={styles.HeroTabsBackground}
    />
  ) : null
}
